import { useMediaQuery } from 'src/lib/use-media-query'
import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, { after: string[]; before: string[] }> =
    {
        desktop: {
            after: [],
            before: ['obtenha'],
        },
        mobile: {
            after: ['bilhetes', 'obtenha'],
            before: [],
        },
    }

export const TextHeaderPt = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    const { after, before } = isDesktop
        ? BREAKPOINT_RULES.desktop
        : BREAKPOINT_RULES.mobile

    return (
        <HighlightedText
            text="Raspe os bilhetes e obtenha o seu bônus"
            highlights={[
                { word: 'obtenha' },
                { word: 'o seu' },
                { word: 'bônus' },
            ]}
            breakAfterWords={after}
            breakBeforeWords={before}
            className={styles.text_header}
        />
    )
}
